import {post} from '../utils/httpUtils';

export const services = {
    // [MODULE SERVICES] NEW SERVICE
    login: (body) => post('auth/', body),
    resetPass: (body) => post('auth/reset-password', body),
    resetPassEmail: (body) => post('auth/reset-password-email', body),
};
